module.exports = __webpack_public_path__ + "static/media/deleteRedIcon.4a460eb1.svg";